import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Addresses_ds_contact_accounts_gridService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { contactTypeIds?: number[], accountTypeId?: number, fullTextSearch?: string, accountIds?: number[], ownerId?: number, advanced?: boolean }): 
  Promise<{ result: { Id?: number, AddressId?: number, FirstName?: string, LastName?: string, Notes?: string, PrimaryEmail?: string, PrimaryTelephone?: string, ReferenceCode?: string, TypeId?: number, AccountsContactsLookup?: { AccountId?: number, ContactId?: number, Account?: { Id?: number, LookupCode?: string, Name?: string, TypeId?: number, Type?: { Name?: string }, OwnersAccountsLookups?: { OwnerId?: number }[] } }[], Address?: { Id?: number, AttentionOf?: string, City?: string, Country?: string, Line1?: string, Line2?: string, PostalCode?: string, State?: string }, Type?: { Name?: string } }[] }> 
  {
    let url = `${environment.backendUrl}api/Addresses/datasources/ds_contact_accounts_grid/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { contactTypeIds?: number[], accountTypeId?: number, fullTextSearch?: string, accountIds?: number[], ownerId?: number, advanced?: boolean, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, AddressId?: number, FirstName?: string, LastName?: string, Notes?: string, PrimaryEmail?: string, PrimaryTelephone?: string, ReferenceCode?: string, TypeId?: number, AccountsContactsLookup?: { AccountId?: number, ContactId?: number, Account?: { Id?: number, LookupCode?: string, Name?: string, TypeId?: number, Type?: { Name?: string }, OwnersAccountsLookups?: { OwnerId?: number }[] } }[], Address?: { Id?: number, AttentionOf?: string, City?: string, Country?: string, Line1?: string, Line2?: string, PostalCode?: string, State?: string }, Type?: { Name?: string } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Addresses/datasources/ds_contact_accounts_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { contactTypeIds?: number[], accountTypeId?: number, fullTextSearch?: string, accountIds?: number[], ownerId?: number, advanced?: boolean, $keys: number[] }): 
  Promise<{ result: { Id?: number, AddressId?: number, FirstName?: string, LastName?: string, Notes?: string, PrimaryEmail?: string, PrimaryTelephone?: string, ReferenceCode?: string, TypeId?: number, AccountsContactsLookup?: { AccountId?: number, ContactId?: number, Account?: { Id?: number, LookupCode?: string, Name?: string, TypeId?: number, Type?: { Name?: string }, OwnersAccountsLookups?: { OwnerId?: number }[] } }[], Address?: { Id?: number, AttentionOf?: string, City?: string, Country?: string, Line1?: string, Line2?: string, PostalCode?: string, State?: string }, Type?: { Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Addresses/datasources/ds_contact_accounts_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}
